import { ArrowUpRight, Phone, Mail } from "lucide-react";

export const CtaBand = () => {
  return (
    <section
      id="contact"
      data-testid="cta-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden border-t border-white/10"
    >
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="noise-overlay" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              — Contact
            </div>
            <h2
              data-testid="cta-title"
              className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9] mb-6"
            >
              Une bosse ?<br />
              <span className="text-white/40">Prenons contact.</span>
            </h2>
            <p className="text-base md:text-lg text-white/70 max-w-xl leading-relaxed mb-10">
              Devis gratuit sous 24h. Nous intervenons partout dans le monde,
              que ce soit pour un particulier, une assurance ou une flotte.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="tel:+33773119016"
                data-testid="cta-phone-btn"
                className="inline-flex items-center gap-3 bg-[#007AFF] hover:bg-[#3B82F6] text-white text-sm font-bold uppercase tracking-widest px-8 py-4 transition-colors accent-glow"
              >
                <Phone className="w-4 h-4" />
                Appel direct
              </a>
              <a
                href="mailto:debosselage@pdrfrance.fr"
                data-testid="cta-email-btn"
                className="inline-flex items-center gap-3 border border-white/20 hover:border-white/60 text-white text-sm font-bold uppercase tracking-widest px-8 py-4 transition-colors"
              >
                <Mail className="w-4 h-4" />
                Envoyer un email
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-[#111111] border border-white/10 p-8 md:p-10 relative">
              <div className="absolute -top-px left-0 w-24 h-[2px] bg-[#007AFF]" />
              <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-6">
                / Coordonnées
              </div>

              <div className="space-y-6">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF] mb-1">
                    Téléphone
                  </div>
                  <div className="font-heading text-xl md:text-2xl font-bold">
                    07 73 11 90 16
                  </div>
                </div>
                <div className="h-px bg-white/10" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF] mb-1">
                    Email
                  </div>
                  <div className="font-heading text-base md:text-lg font-semibold break-all">
                    debosselage@pdrfrance.fr
                  </div>
                </div>
                <div className="h-px bg-white/10" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF] mb-1">
                    Zone d'intervention
                  </div>
                  <div className="font-heading text-base md:text-lg font-semibold">
                    5 continents · France & international
                  </div>
                </div>
                <div className="h-px bg-white/10" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF] mb-1">
                    Disponibilité
                  </div>
                  <div className="font-heading text-base md:text-lg font-semibold">
                    Lun-Sam · 8h - 19h
                  </div>
                </div>
              </div>

              <a
                href="#contact"
                data-testid="cta-quote-btn"
                className="mt-8 w-full inline-flex items-center justify-between bg-[#007AFF] hover:bg-[#3B82F6] text-white text-xs font-bold uppercase tracking-widest px-6 py-4 transition-colors"
              >
                Demande de devis
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
